export interface OrderHistoryPage {
  current_page: number;
  data: OrderHistoryItem[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  next_page_url: string;
  path: string;
  per_page: number;
  prev_page_url: string;
  to: number;
  total: number;
}

export interface OrderHistoryItem {
  media: string;
  order_number: string;
  title: string;
  authors: string;
  material: string;
  created_at: string;
  price: string;
  quantity: number;
  currency: string;
  shipping_const: string;
  order_id: string;
  payment_method: string | 'online' | 'cash_on_deliver';
  payment_status: string | 'new' | 'error' | 'canceled';
  order_status_type: PaymentType;
}

export enum PaymentType {
  ORDER_TYPE_WAITING_FORM_PAYMENT = 'waiting_for_payment',
  ORDER_TYPE_CANCELED = 'canceled',
  ORDER_TYPE_PAYMENT_PROCESSING = 'payment_processing',
  ORDER_TYPE_PAYMENT_ERROR = 'payment_error',
  ORDER_TYPE_PAYED = 'payed',
  ORDER_TYPE_SHIPPED = 'shipped',
}
